import Vue from 'vue'
import Vuex from 'vuex'
import { ElementApiModule } from 'clockvine-vue'
import home from './homepage-graphic/store/index.js'

Vue.use(Vuex)

var lang = document.querySelector('html').getAttribute('data-sitehandle');

export default new Vuex.Store({
    modules: {
        customers: new ElementApiModule(`/${lang}/customers.json`, { debounce: 1000 }),
        industries: new ElementApiModule(`/${lang}/industries.json`, { debounce: 1000 }),
        resources: new ElementApiModule(`/${lang}/resources.json`, { debounce: 1000 }),
        resourceTypes: new ElementApiModule(`/${lang}/resourceTypes.json`, {
            debounce: 1000,
            idProperty: 'slug',
        }),
        resourceTopics: new ElementApiModule(`/${lang}/resourceTopics.json`, { debounce: 1000 }),
        blog: new ElementApiModule(`/${lang}/blog.json`, { debounce: 1000 }),
        blogCategories: new ElementApiModule(`/${lang}/blogCategories.json`, { debounce: 1000 }),
        partners: new ElementApiModule(`/${lang}/partners.json`, { debounce: 1000 }),
        partnerCategories: new ElementApiModule(`/${lang}/partnerCategories.json`, { debounce: 1000 }),
        partnerRegions: new ElementApiModule(`/${lang}/partnerRegions.json`, { debounce: 1000 }),
        partnerCertifications: new ElementApiModule(`/${lang}/partnerCertifications.json`, { debounce: 1000 }),
        news: new ElementApiModule(`/${lang}/news.json`, { debounce: 1000 }),
        home
    },
})
